<div class="user-status-widget {{ item[field] }}">
  <i
    class="user-status-icon fas"
    [ngClass]="{ 'fa-check': item[field] === 'active', 'fa-spinner': item[field] === 'inactive' }">
  </i>
  {{ 'market_discovery.user.status.' + item[field] | translate }}
</div>
